import classNames from "classnames";
import moment from "moment";
import React from "react";
import { marpolUtils } from "../../../../../redux/app/marpol";
import { TBFL2Record } from "../../../../../redux/app/bfl-2/@types";
import { TBFL2C1 } from "../../../../../redux/app/bfl-2/groups/bfl2-c";
import Biofouling2TableRows from "../BioTableRows";

type OwnProps = {
	biofoulingRecord: TBFL2Record;
	isStrikedOff?: boolean;
};
type BFL2C1PreviewProps = OwnProps;
function BFL2C1Preview(props: BFL2C1PreviewProps) {
	const biofoulingRecord = props.biofoulingRecord as TBFL2C1;
	const operationDate = moment(
		biofoulingRecord.selectedDate,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<Biofouling2TableRows
				record={biofoulingRecord}
				tableRows={[
					[operationDate, "C", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, 3, renderItem3()],
					[null, null, 4, renderItem4()],
					[null, null, 5, renderItem5()],
					[null, null, "NOTE", biofoulingRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item1.descriptionOfAnyObservedReduction
					? biofoulingRecord.item1.descriptionOfAnyObservedReduction
					: "-----"}
			</h4>
		);
	}
	function renderItem2() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item2.descriptionOfOperation
					? biofoulingRecord.item2.descriptionOfOperation
					: "-----"}
			</h4>
		);
	}
	function renderItem3() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item3.locationOfAnyInstances
					? biofoulingRecord.item3.locationOfAnyInstances
					: "-----"}
			</h4>
		);
	}
	function renderItem4() {
		return (
			<>
				<h4 className="font-medium uppercase">
					{biofoulingRecord.item4.recordsOfMaintenance
						? biofoulingRecord.item4.recordsOfMaintenance
						: "-----"}
				</h4>
				{biofoulingRecord.item4.maintenanceAttachment != " " ? (
					<h3 className="font-medium uppercase">
						Attachment: {biofoulingRecord.item4.maintenanceAttachment}
					</h3>
				) : null}
			</>
		);
	}
	function renderItem5() {
		return (
			<h4 className="font-medium uppercase">
				{biofoulingRecord.item5.contingencyActions
					? biofoulingRecord.item5.contingencyActions
					: "-----"}
			</h4>
		);
	}

	return renderMain();
}

export default BFL2C1Preview;
